import { render, staticRenderFns } from "./ProductsComponent.vue?vue&type=template&id=0fba7467&scoped=true&"
import script from "./ProductsComponent.vue?vue&type=script&lang=js&"
export * from "./ProductsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductsComponent.vue?vue&type=style&index=0&id=0fba7467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba7467",
  null
  
)

export default component.exports